export interface IApplication {
  id?: string;
  name: string;
}

export interface ICustomerDetails {
  id: number;
  name: string;
  email: string;
  photo: string;
}

export interface ICustomerList {
  id: number;
  name: string;
  email: string;
  photo: string;
}

export enum ERefundMotive {
  REQUEST = 'REQUEST',
  APROVE = 'APROVE',
  REPROVE = 'REPROVE',
}

export enum ERefundMotiveId {
  ERROR_IN_THE_PAYMENT_METHOD = '1e18ef27-9873-499b-8c88-279ed1df3833',
  NOT_WHAT_I_EXPECTED = '3b1dd187-65e3-4a18-97f1-b354dae5e79e',
  I_DIDNT_MAKE_THIS_PURCHASE = '7a488dab-81ab-4b5c-835d-7297b3c864e3',
  OTHER_REASON = 'fd563469-d919-457a-9e44-36f2a587018a',
  PRODUCT_TOOK_A_LONG_TIME_TO_BE_DELIVERED = 'ba8b0aaf-5a7e-48f6-9050-3c8a9f697e5d',
  DUPLICATE_PURCHASE = 'b5afed42-efff-4ca5-8a43-6ca45b932351',
  PRODUCER_REQUEST = '9209ff4e-65d8-477c-8dce-aece84669305',
  LEGAL_PROCESS = 'e4b4ef4f-4322-451c-a7bd-c97797ef8811',
  SUSPICIOUS_SALE = 'aa932d38-2f85-4c05-944d-304161392273',
}

export enum EReproveMotiveId {
  OTHER_REASON = 'ea26df9d-f2d9-4c60-8473-2ea2a72a2ed3',
}

export interface IRefundMotive {
  id?: string;
  description: string;
  type: ERefundMotive;
}

export interface IRequestStatus {
  id: string;
  description: string;
}

export interface IRefund {
  id?: string;
  buyer_id: number;
  buyer_name: string;
  application_id: string;
  application: IApplication;
  producer_id: number;
  invoice_id: number;
  invoice_value: number;
  invoice_payment_date: Date;
  request_motive_id: string;
  request_motive: IRefundMotive;
  description: string;
  request_status_id?: string;
  requested_after_deadline: boolean;
  request_status: IRequestStatus;
  reprove_motive_id?: string;
  reprove_motive: IRefundMotive;
  reprove_justification?: string;
  due_date: Date;
  created_at: Date;
  updated_at: Date;
  checked?: boolean;
}

export interface ISendPartialRefund {
  motive_id: string;
  invoice_id: number;
  description?: string;
  amount: number;
}

export interface ISendRefund {
  invoice_id: number;
  motive_id: string;
  motive: string;
}
